/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_qQ_113_81 as Componente_qQ_113_81,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_MQ as MQ,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_SelectorMultiple as SelectorMultiple,
  rec_api as api,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function CerrarOrden({ orden: e, onClose: t, onCerrada: n }) {
  let [r, i] = (0, React.useState)(`REALIZADA`),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(``),
    [l, u] = (0, React.useState)(``),
    [f, p] = (0, React.useState)(null),
    [m, h] = (0, React.useState)(``),
    [g, _] = (0, React.useState)(!1),
    v = r === `REALIZADA`;
  (0, React.useEffect)(() => {
    let t = !0;
    return (
      api(
        `/transporte/tarifa?origen=${encodeURIComponent(e.sede ?? ``)}&destino=${encodeURIComponent(e.destino ?? ``)}&tipo=${encodeURIComponent(e.tipoUnidad ?? ``)}`,
      )
        .then((e) => {
          t && e?.precio && (p(e), o(String(e.precio)));
        })
        .catch(() => {}),
      () => {
        t = !1;
      }
    );
  }, [e.sede, e.destino, e.tipoUnidad]);
  let y = f && a !== `` && Number(a) !== Number(f.precio);
  async function b(t) {
    if ((t.preventDefault(), !g)) {
      (_(!0), h(``));
      try {
        (await api(`/transporte/ordenes/${e.id}/cerrar`, {
          method: `POST`,
          body: JSON.stringify({
            estado: r,
            costo: a === `` ? null : Number(a),
            penalidad: s === `` ? null : Number(s),
            observacion: l,
          }),
        }),
          n());
      } catch (e) {
        h(e.message);
      } finally {
        _(!1);
      }
    }
  }
  return (
    <Modal
      titulo={`Cerrar ${e.codigo}`}
      onClose={t}
      children={
        <form
          onSubmit={b}
          aria-label={`Cerrar orden`}
          className={`flex flex-col gap-3`}
          children={[
            <Componente_qQ_113_81 orden={e} />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `¿Qué pasó?`,
                <SelectorMultiple
                  value={r}
                  onChange={i}
                  opciones={[
                    {
                      value: `REALIZADA`,
                      label: `Se hizo el servicio`,
                    },
                    {
                      value: `CANCELADA`,
                      label: `Se canceló con aviso`,
                    },
                    {
                      value: `RECHAZADA`,
                      label: `Llegó la unidad y no salió nadie`,
                    },
                  ]}
                />,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Costo`,
                <input
                  type={`number`}
                  min={`0`}
                  step={`0.01`}
                  value={a}
                  onChange={(e) => o(e.target.value)}
                  className={Lo}
                />,
              ]}
            />,
            f ? (
              <p
                className={`-mt-2 text-xs text-(--text)`}
                children={[
                  `Lo acordado para `,
                  f.origen,
                  ` → `,
                  f.destino,
                  ` en `,
                  f.tipo,
                  ` es`,
                  ` `,
                  MQ(f.precio),
                  `.`,
                  y && (
                    <span
                      className={`text-(--warning)`}
                      children={` Vas a registrar otro precio.`}
                    />
                  ),
                ]}
              />
            ) : (
              <p
                className={`-mt-2 text-xs text-(--text)`}
                children={`Esta ruta no tiene precio acordado. Si se repite, conviene agregarla en Tarifario.`}
              />
            ),
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Penalidad`,
                <input
                  type={`number`}
                  min={`0`}
                  step={`0.01`}
                  value={s}
                  onChange={(e) => c(e.target.value)}
                  className={Lo}
                />,
              ]}
            />,
            !v && (
              <p
                className={`-mt-2 text-xs text-(--text)`}
                children={`Aunque no se haya hecho, la unidad se movió y se paga. Se acuerda con el proveedor.`}
              />
            ),
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                v ? `Observación` : `¿Qué pasó?`,
                <input
                  value={l}
                  onChange={(e) => u(e.target.value)}
                  placeholder={
                    v ? `Opcional` : `Queda registrado por qué se paga`
                  }
                  className={Lo}
                />,
              ]}
            />,
            m && <p className={`text-sm text-(--error)`} children={m} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={t}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={g}
                  className={Ro}
                  children={g ? `Guardando…` : `Cerrar orden`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
